import { render, staticRenderFns } from "./OrderManager.vue?vue&type=template&id=2c0c3c32&scoped=true"
import script from "./OrderManager.vue?vue&type=script&lang=js"
export * from "./OrderManager.vue?vue&type=script&lang=js"
import style1 from "./OrderManager.vue?vue&type=style&index=1&id=2c0c3c32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c3c32",
  null
  
)

export default component.exports